__webpack_require__.p = "/shared-mailboxes/referrals-hub/";